export default "__VITE_ASSET__Dw9QvsJz__"